module.exports = "pegasus_template/assets/blocks/column-14-theme2.png";